"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseTruncatePipeModule = /** @class */ (function () {
    function FuseTruncatePipeModule() {
    }
    return FuseTruncatePipeModule;
}());
exports.FuseTruncatePipeModule = FuseTruncatePipeModule;
